// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCall0124 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.67628 3.21395L8.07762 3.21398C9.26003 3.20246 10.2678 4.0692 10.4342 5.24691C10.5285 5.96165 10.7033 6.66344 10.9547 7.33718L11.0124 7.51069C11.2488 8.32607 11.0281 9.21235 10.4217 9.82549L9.81693 10.4299L9.94999 10.6383C10.8473 11.9948 12.009 13.1566 13.3656 14.0539L13.5729 14.1859L14.1813 13.5792C14.7917 12.9756 15.6778 12.7551 16.4918 12.9909L16.665 13.0485C17.3404 13.3005 18.0422 13.4753 18.7636 13.5705C19.9481 13.7376 20.8193 14.7658 20.7898 15.943L20.7898 18.3486C20.7925 19.0119 20.5154 19.6456 20.0266 20.0941C19.5379 20.5425 18.8827 20.7641 18.2085 20.703C15.6213 20.4219 13.1361 19.5378 10.9584 18.1256C8.92561 16.8338 7.20213 15.1104 5.91393 13.0831C4.493 10.8896 3.60872 8.39235 3.33159 5.78181C3.27208 5.12322 3.4921 4.46994 3.93792 3.98156C4.38371 3.49321 5.01421 3.21468 5.67628 3.21395ZM8.94807 5.44994C8.88795 5.02461 8.52182 4.70972 8.09223 4.71391L5.67712 4.71394C5.43682 4.71421 5.20772 4.81542 5.04576 4.99284C4.88381 5.17025 4.80388 5.40756 4.82435 5.63511C5.07545 7.99967 5.88001 10.2718 7.1764 12.273C8.35004 14.12 9.91595 15.6859 11.7688 16.8633C13.7554 18.1517 16.0166 18.956 18.3571 19.2105C18.597 19.2322 18.835 19.1517 19.0126 18.9888C19.1902 18.8259 19.2908 18.5957 19.2898 18.3517L19.2901 15.9244C19.3008 15.49 18.9844 15.1165 18.5608 15.0567C17.7339 14.9477 16.922 14.7454 16.1389 14.4532C15.8262 14.3356 15.4736 14.4108 15.239 14.6428L14.2194 15.6624C13.9806 15.9012 13.6118 15.951 13.3183 15.7841C11.1909 14.5744 9.42945 12.8129 8.21978 10.6855C8.05289 10.392 8.10268 10.0232 8.34142 9.78449L9.35812 8.7678C9.59303 8.53025 9.66822 8.1777 9.55003 7.86328C9.25844 7.08185 9.05619 6.26995 8.94807 5.44994Z"
				/>
			</Svg>
		);
	}
);
SvgCall0124.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCall0124;
